import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CronJobsRoutes: Routes = [
  {
    path: "cron-jobs",
    loadComponent: () =>
      import("./cron-jobs.component").then((m) => m.CronJobsComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./cron-job-form/cron-job-form.component").then(
            (m) => m.CronJobFormComponent,
          ),
      },
    ],
  },
];
